import { Component, Inject, OnInit } from '@angular/core';
import { AppService } from '../../../../../app.service';
import { ClearFlagVM } from '../../../favourite-dialog/favourite-dialog-modal';
import { DigitalFormService } from '../../digital-form.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-clear-flag-dialog',
  templateUrl: './clear-flag-dialog.component.html',
  styleUrls: ['./clear-flag-dialog.component.scss']
})
export class ClearFlagDialogComponent implements OnInit {
  comment:string;
  flagClear:boolean;
  alreadychanged:boolean=false;
  constructor(private _dialogRef: MatDialogRef<ClearFlagDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) private _data: any,private _appService: AppService,
    private _formService:DigitalFormService) { }

  ngOnInit() {
    this.comment=this._data.comment;
    this.flagClear=this._data.flagClear;
    if(this.comment!="" && this.comment!=null && this.flagClear==true){
      this.alreadychanged=true;
    }
  }

  SaveLeave(){
    let clearflag = new ClearFlagVM();
    clearflag.Id = 2;
    clearflag.Comment = this.comment;
    clearflag.FlagField=false;
    this._dialogRef.close(clearflag);
  }
  SaveClear(){

    let clearflag = new ClearFlagVM();
    clearflag.Id = 1;
    clearflag.Comment = this.comment;
    clearflag.FlagField=true;
    this._dialogRef.close(clearflag);
  }

  SaveReset(){
    let clearflag = new ClearFlagVM();
    clearflag.Id = 3;
    clearflag.Comment = this.comment;
    clearflag.FlagField=false;
    this._dialogRef.close(clearflag);
  }

  onNoClick(){
    let clearflag = new ClearFlagVM();
    clearflag.Id = 0;
    clearflag.Comment = this.comment;
    clearflag.FlagField=false;
    this._dialogRef.close(clearflag);
  }

}
